import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.isAuthenticated()) {
      return true;
    }

    // If user is already authenticated, redirect based on role
    const user = this.authService.getCurrentUser();
    if (user?.role === 'admin') {
      return this.router.createUrlTree(['/dashboard']);
    } else {
      return this.router.createUrlTree(['/my-reservations']);
    }
  }
}